module.exports = __webpack_public_path__ + "media/images/responsive/top/flow_step04-1b39092a066ccb9defddeb60bcd2b2e5.jpg";